import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import { Errors } from "../../../../../utils/errors";
import { RegxExpression, Select2Data } from "../../../../../utils/common";
import classNames from "classnames";
import { allCategoryWithoutId } from "../../../../../utils/apis/master/Master";
const Stepeight = ({ prevStep, nextStep, setStepData, savedData }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    setValue,
    trigger,
  } = useForm({
    defaultValues: savedData || {}, // Initialize with saved data if available
  });

  useEffect(() => {
    // Reset form with saved data when component loads
    if (savedData) {
      reset(savedData);
    }
  }, [savedData, reset]);


  const getCategories = async () => {
    const res = await allCategoryWithoutId()
    if (res?.success) {
      const data = await Select2Data(res?.data, "category_id", false)
      setSelectedOption(data)
    }
  }

  useEffect(() => {
    getCategories()
  }, [])


  const onSubmit = async (d) => {


    const data = getValues();
    console.log("onSubmit", data,JSON.stringify(data?.category_id))
    // setStepData({
    //   category_id: JSON.stringify(data?.category_id?.map((item) => item?.value))
    // });

    setStepData(data);


    nextStep()
  };


  return (
    <>
      <section className="personal-details-form ">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="stepeight">



            <div className="row itemDetails">
              {/* <div className="col-lg-12">
              <div className="field-bottom mb-3">
                <Form.Label className="required">Category*</Form.Label>
                <Select
                  defaultValue={selectedOption}
                  onChange={setSelectedOption}
                  options={options}
                  classNamePrefix="buisness"
                  isMulti="true"
                  placeholder="Select Category"
                />
              </div>
            </div> */}

              <div className="col-md-12">
                <div className="field-bottom">
                  <Form.Label className="required">Category*</Form.Label>


                  <Controller
                    name="category_id" // name of the field
                    {...register("category_id", {
                      required: "Category is required",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        defaultValue={selectedOption}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption?.value); // Update Controller's value
                          setValue("category_id", selectedOption);
                        }}
                        options={selectedOption}
                        classNamePrefix="buisness"
                        placeholder="Select Category"
                      />
                    )}
                  />
                  {errors.category_id && (
                    <span className="text-danger">
                      {errors.category_id?.message}
                    </span>
                  )}
                </div>
              </div>

            </div>
          </div>
          <div className=" text-center apply_now_btn">
            <Button onClick={prevStep} className="back-btn me-3">
              Back
            </Button>

            {/* <div className="registerContinueMain"> */}
            <Button type="submit" className="tabs-btn">
              Save & Next
            </Button>

            {/* </div> */}

          </div>
        </Form>
      </section>
    </>
  );
};

export default Stepeight;
